// IE 2026 10 25 / ODOO-348925 (заказ Игоря: колонка-ссылка на строку табличной части того же документа — AttrRowLink, схема PLAN-MAP-SET v3)
// Чистая логика колонки AttrRowLink (без Vue, DOM и стора). Колонка табличной части ссылается на строку ДРУГОЙ табличной части той же записи
// (rows_binding: doc.nodes | doc.fields | doc.horizons; иерархия — вложенностью строк attrs). В строке хранится только ключ: {<база>: {<key_binding>: '<ключ>'}}
// (например {node: {name: 'n1'}}); title не пишется — показывается живым из строки-источника. BE объявляет ОБЫЧНУЮ группу колонок из двух листей:
// <база>.<title_binding> (node.title) и <база>.<key_binding> (node.name), оба attr_type 'AttrRowLink' с params rows_binding / key_binding / title_binding;
// часть листа (title / key) — по суффиксу binding. Ввод в любой лист — подбор из строк источника, выбор пишет ключ. Ключ, которого нет в источнике, —
// «Not found: <ключ>», значение не теряется; переименование name в источнике ссылки не переписывает (решение Игоря).
// title-лист: на объект ссылки (row.node) ставится НЕперечислимое свойство-аксессор <title_binding> (get → ключ, set → пишет ключ): ячейка грида читает ключ,
// карта колонки показывает по нему живой title; в JSON записи (JSON.stringify / deepCopy) аксессор не попадает.
// Выключатель fe.ux.rowLink (дефолт ВКЛ) читает AttrGrid, сюда приходит setting(key, def). Юнит-тест: node --test tests/unit/rowLink.test.mjs
export const RL_FLAG = 'fe.ux.rowLink'   // IE 2026 10 25 / ODOO-348925
export const RL_TYPE = 'AttrRowLink'   // IE 2026 10 25 / ODOO-348925
export function rowLinkOn(setting) {
    try { return (typeof setting === 'function' ? setting(RL_FLAG, true) : true) !== false } catch (e) { return true }
}

const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)
export function getPath(obj, path) {
    if (obj === null || obj === undefined || path === null || path === undefined || path === '') return undefined
    let cur = obj
    for (const p of String(path).split('.')) {
        if (cur === null || cur === undefined || typeof cur !== 'object') return undefined
        cur = cur[p]
    }
    return cur
}
export function setPath(obj, path, value) {
    const parts = String(path).split('.')
    let cur = obj
    for (let i = 0; i < parts.length - 1; i++) {
        const p = parts[i]
        if (cur[p] === null || cur[p] === undefined || typeof cur[p] !== 'object') cur[p] = {}
        cur = cur[p]
    }
    cur[parts[parts.length - 1]] = value
}
// ключ как строка: null / undefined / объект — ''
export function keyStr(v) {
    if (v === null || v === undefined || typeof v === 'object') return ''
    return String(v)
}
// поле на языке пользователя (<поле>_<lang>), иначе базовое
export function localized(obj, path, lang) {
    if (!isObj(obj) || !path) return ''
    const loc = lang ? getPath(obj, `${path}_${lang}`) : undefined
    const v = typeof loc === 'string' && loc.trim() !== '' ? loc : getPath(obj, path)
    return v === null || v === undefined || typeof v === 'object' ? '' : String(v)
}

// ---------- конфигурация ----------
const DEF = { key_binding: 'name', title_binding: 'title', children_path: 'attrs' }
// attr — описание листа колонки (ключи верхнего уровня; запасной — attr.params.<ключ>). cfg: {binding, rows_binding, key_binding, title_binding, children_path,
// part: 'title' | 'key', base, keyPath, titlePath}; errors: [{code, params?}] (no-binding / no-rows-binding / bad-part)
export function rlConfig(attr) {
    const a = isObj(attr) ? attr : {}
    const p = isObj(a.params) ? a.params : {}
    const pick = (k) => {
        const v = a[k] !== undefined && a[k] !== null && a[k] !== '' ? a[k] : p[k]
        return v === undefined || v === null || v === '' ? DEF[k] : String(v)
    }
    const cfg = { binding: keyStr(a.binding), rows_binding: pick('rows_binding') || '', key_binding: pick('key_binding'), title_binding: pick('title_binding'),
        children_path: pick('children_path'), part: null, base: '', keyPath: '', titlePath: '' }
    const errors = []
    if (!cfg.binding) errors.push({ code: 'no-binding' })
    if (!cfg.rows_binding) errors.push({ code: 'no-rows-binding' })
    cfg.part = rlPart(cfg.binding, cfg)
    if (cfg.binding && !cfg.part) errors.push({ code: 'bad-part', params: { binding: cfg.binding } })
    if (cfg.part) {
        const suffix = cfg.part === 'title' ? cfg.title_binding : cfg.key_binding
        cfg.base = cfg.binding.slice(0, cfg.binding.length - suffix.length - 1)
        cfg.keyPath = `${cfg.base}.${cfg.key_binding}`
        cfg.titlePath = `${cfg.base}.${cfg.title_binding}`
    }
    return { cfg, errors }
}
// часть листа по суффиксу binding: '<база>.<title_binding>' → 'title', '<база>.<key_binding>' → 'key'; иначе null
export function rlPart(binding, cfg) {
    const b = keyStr(binding)
    if (!b || !cfg) return null
    if (cfg.title_binding && b.endsWith('.' + cfg.title_binding) && b.length > cfg.title_binding.length + 1) return 'title'
    if (cfg.key_binding && b.endsWith('.' + cfg.key_binding) && b.length > cfg.key_binding.length + 1) return 'key'
    return null
}

// ---------- источник ----------
// обход строк источника с иерархией (children_path, по умолчанию attrs): fn(row, depth, isGroup)
export function walkRows(rows, cfg, fn, depth = 0) {
    if (!Array.isArray(rows)) return
    const kids = (cfg && cfg.children_path) || 'attrs'
    for (const row of rows) {
        if (!isObj(row)) continue
        const ch = row[kids]
        const isGroup = Array.isArray(ch) && ch.length > 0
        fn(row, depth, isGroup)
        if (isGroup) walkRows(ch, cfg, fn, depth + 1)
    }
}
const LANGS = ['', 'en', 'uk', 'ru']
// пункты подбора: [{id: ключ, title: название на языке пользователя (или ключ), code: ключ, caption: 'ключ · название', titles_alt, depth, isGroup}] — ЛИСТЬЯ
// источника (строки без дочерних) с непустым ключом, в порядке обхода; группы в подбор не попадают (ответ ie-dm7 #104209). index: Map(ключ → первая строка),
// с группами — уже записанный ключ группы показывается её названием, не «Not found»; dupKeys: ключи, встреченные повторно (работает первая строка)
export function rlItems(rows, cfg, lang) {
    const items = [], index = new Map(), dupKeys = []
    walkRows(rows, cfg, (row, depth, isGroup) => {
        const key = keyStr(getPath(row, cfg.key_binding))
        if (key.trim() === '') return
        if (index.has(key)) { if (!dupKeys.includes(key)) dupKeys.push(key); return }
        const shown = localized(row, cfg.title_binding, lang)
        const title = shown.trim() !== '' ? shown : key
        const alt = []
        for (const l of LANGS) {
            const v = l ? getPath(row, `${cfg.title_binding}_${l}`) : getPath(row, cfg.title_binding)
            if (typeof v === 'string' && v.trim() !== '' && v !== title && !alt.includes(v)) alt.push(v)
        }
        const it = { id: key, title, code: key, caption: title !== key ? `${key} · ${title}` : key, titles_alt: alt, depth, isGroup }
        if (!isGroup) items.push(it)   // IE 2026 10 25 / ODOO-348925: группы — только в index (показ), не в подбор
        index.set(key, it)
    })
    return { items, index, dupKeys }
}
// подпись источника для живости: ключи, названия (все языки), вложенность; прочие поля строк в неё не входят
export function rlSig(rows, cfg, lang = '') {
    const parts = [lang || '']
    walkRows(rows, cfg, (row, depth) => {
        const t = [keyStr(getPath(row, cfg.key_binding)), depth]
        for (const l of LANGS) t.push(keyStr(l ? getPath(row, `${cfg.title_binding}_${l}`) : getPath(row, cfg.title_binding)))
        parts.push(t.join('\u0001'))
    })
    return parts.join('\u0002')
}

// ---------- строка ссылки ----------
export function rlLinkObj(row, cfg) { return isObj(row) ? getPath(row, cfg.base) : undefined }
export function rlKey(row, cfg) {
    const link = rlLinkObj(row, cfg)
    return isObj(link) ? keyStr(getPath(link, cfg.key_binding)) : ''
}
// текст ячейки листа: title-лист — название строки-источника; ключа нет в источнике — t('Not found: {key}'); key-лист — сам ключ
// (notFound — для курсива); пустой ключ — ''
export function rlShown(row, cfg, index, t) {
    const key = rlKey(row, cfg)
    if (!key) return { key, text: '', notFound: false }
    const it = index && index.get ? index.get(key) : null
    if (cfg.part === 'key') return { key, text: key, notFound: !it }
    if (it) return { key, text: it.title, notFound: false }
    return { key, text: tr(t, 'Not found: {key}', { key }), notFound: true }
}
// показ значения ячейки title-листа картой колонки (wijmo DataMap.getDisplayValue): значение — ключ (аксессор); строка с СОХРАНЁННЫМ title (старые данные,
// аксессор не ставится) — значение и есть название: показываем как есть, если оно название строки источника; иначе — «Not found»
export function rlDisplay(value, cfg, index, t) {
    const v = keyStr(value)
    if (!v) return ''
    const it = index && index.get ? index.get(v) : null
    if (cfg.part === 'key') return v
    if (it) return it.title
    if (index && index.values) for (const x of index.values()) if (x.title === v || (x.titles_alt || []).includes(v)) return v
    return tr(t, 'Not found: {key}', { key: v })
}
function tr(t, text, params) {
    if (typeof t === 'function') { try { const s = t(text, params); if (typeof s === 'string') return s } catch (e) { /* без словаря */ } }
    return String(text).replace(/\{(\w+)\}/g, (m, k) => (params && params[k] !== undefined ? String(params[k]) : m))
}
// введённый текст (ключ, «ключ · название», название на любом языке) → ключ. {key, refused}: '' — очистка ссылки (key ''); не найдено — refused
// порядок: точный ключ, точная подпись пункта, точное название, название на другом языке, затем то же без учёта регистра и пробелов по краям
export function rlResolve(text, items) {
    const s = text === null || text === undefined ? '' : String(text)
    if (s.trim() === '') return { key: '', refused: false }
    const list = Array.isArray(items) ? items : []
    const tests = [
        (it) => it.id === s, (it) => it.caption === s, (it) => it.title === s, (it) => (it.titles_alt || []).includes(s),
    ]
    for (const f of tests) { const it = list.find(f); if (it) return { key: it.id, refused: false } }
    const low = s.trim().toLowerCase()
    const lt = (v) => String(v).trim().toLowerCase() === low
    const tests2 = [(it) => lt(it.id), (it) => lt(it.caption), (it) => lt(it.title), (it) => (it.titles_alt || []).some(lt)]
    for (const f of tests2) { const it = list.find(f); if (it) return { key: it.id, refused: false } }
    return { key: '', refused: true }
}
// запись выбранного ключа в строку: <база>.<key_binding> = key (промежуточный объект создаётся); соседние поля строки и объекта ссылки не трогаются,
// title не пишется. {changed, old}
export function rlWrite(row, cfg, key) {
    const old = rlKey(row, cfg)
    const k = keyStr(key)
    if (!isObj(row) || old === k && isObj(rlLinkObj(row, cfg))) return { changed: false, old }
    setPath(row, cfg.keyPath, k)
    return { changed: old !== k, old }
}

// ---------- аксессор title-листа ----------
// ставится на объект ссылки, если title_binding — простое имя и у объекта нет СОБСТВЕННОГО сохранённого значения (данные не меняются). true — поставлен сейчас
export function rlInstall(link, cfg) {
    if (!isObj(link) || !cfg || !cfg.title_binding || cfg.title_binding.includes('.')) return false
    const name = cfg.title_binding, kb = cfg.key_binding
    const d = Object.getOwnPropertyDescriptor(link, name)
    if (d) return false   // уже стоит (наш аксессор) или сохранённое значение — не трогаем
    const get = function () { return keyStr(getPath(this, kb)) }
    get.__rowLink = true
    Object.defineProperty(link, name, {
        configurable: true, enumerable: false, get,
        set(v) { setPath(this, kb, keyStr(v)) },
    })
    return true
}
// новая строка грида (_meta.new): общий путь создания строки пишет введённый текст по binding листа — у title-листа это сохранённый <база>.<title_binding>.
// Его убираем (title не хранится) и ставим аксессор. У прочих строк сохранённое значение не трогается. true — убрано
export function rlFixNewRow(row, cfg) {
    if (!isObj(row) || !cfg || !isObj(row._meta) || !row._meta.new) return false
    const link = rlLinkObj(row, cfg)
    if (!isObj(link) || !cfg.title_binding || cfg.title_binding.includes('.')) return false
    const d = Object.getOwnPropertyDescriptor(link, cfg.title_binding)
    if (!d || d.get) return false
    delete link[cfg.title_binding]
    rlInstall(link, cfg)
    return true
}
export function rlInstalled(link, cfg) {
    if (!isObj(link) || !cfg) return false
    const d = Object.getOwnPropertyDescriptor(link, cfg.title_binding)
    return !!(d && d.get && d.get.__rowLink)
}
// аксессоры по всем строкам таблицы ссылок (вложенные строки — по childItemsPath грида); число поставленных
export function rlInstallAll(rows, cfgs, childItemsPath = 'attrs') {
    let n = 0
    const list = Array.isArray(cfgs) ? cfgs : [cfgs]
    const walk = (arr) => {
        if (!Array.isArray(arr)) return
        for (const row of arr) {
            if (!isObj(row)) continue
            for (const cfg of list) if (cfg && cfg.part === 'title' && rlInstall(rlLinkObj(row, cfg), cfg)) n++
            if (childItemsPath && Array.isArray(row[childItemsPath])) walk(row[childItemsPath])
        }
    }
    walk(rows)
    return n
}

// ---------- IE 2026 10 25 / ODOO-348878 (заказ Игоря: подбор RowLink — Enter и закреплённые колонки) (p041) ----------
// Enter в редакторе листа при открытом списке подбора: {index, how} либо null (Enter не коммитит, ввод и список остаются). Порядок: подсвеченный пункт ('highlight') →
// точное совпадение текста (ключ / подпись / название на любом языке, 'exact') → пункт, который показывает серая подсказка (первое название, начинающееся с набранного,
// как ghost-текст AttrGrid.dropdown_setItems, 'suggestion') → единственный пункт списка ('single'). Пустой текст без подсветки — null (очистка — прежним путём)
export function rlPickOnEnter(items, highlighted, text) {
    if (!Array.isArray(items) || !items.length) return null
    if (Number.isInteger(highlighted) && highlighted >= 0 && highlighted < items.length) return { index: highlighted, how: 'highlight' }
    const s = text === null || text === undefined ? '' : String(text).trim()
    if (!s) return null
    const ex = rlResolve(s, items)
    if (!ex.refused && ex.key) { const i = items.findIndex((it) => it && String(it.id) === ex.key); if (i >= 0) return { index: i, how: 'exact' } }
    const q = s.toLowerCase()
    const p = items.findIndex((it) => it && String(it.title === null || it.title === undefined ? '' : it.title).toLowerCase().startsWith(q))
    if (p >= 0) return { index: p, how: 'suggestion' }
    if (items.length === 1) return { index: 0, how: 'single' }
    return null
}
// введённый текст → ключ с недонабором (Tab, уход из ячейки, Enter без списка): сначала точный rlResolve; иначе пункты, у которых ключ / подпись / название (все языки)
// СОДЕРЖИТ текст без учёта регистра, — один такой пункт принимается; несколько — те, что НАЧИНАЮТСЯ с текста, если такой один; иначе отказ (refused)
export function rlLooseResolve(text, items) {
    const ex = rlResolve(text, items)
    if (!ex.refused) return ex
    const list = Array.isArray(items) ? items : []
    const q = String(text).trim().toLowerCase()
    if (!q) return ex
    const vals = (it) => [it.id, it.caption, it.title, ...(it.titles_alt || [])].filter((v) => v !== null && v !== undefined).map((v) => String(v).toLowerCase())
    const uniq = (arr) => { const ids = new Set(arr.map((it) => String(it.id))); return ids.size === 1 ? { key: String(arr[0].id), refused: false } : null }
    const inc = list.filter((it) => it && vals(it).some((v) => v.includes(q)))
    if (!inc.length) return ex
    const u1 = uniq(inc); if (u1) return u1
    const pre = inc.filter((it) => vals(it).some((v) => v.startsWith(q)))
    return (pre.length && uniq(pre)) || ex
}
// барьер объединения ячеек грида (CustomMergeManager): лист AttrRowLink — ячейка подбора, она не сливается с пустыми соседями закреплённой области и не поглощается ими
// (иначе правка уходит в корень диапазона, а список подбора не открывается). rlCols — AttrGrid._rlCols (есть только при fe.ux.rowLink и настроенных листьях)
export function rlMergeBarrier(attr, rlCols) {
    return !!(attr && attr.attr_type === RL_TYPE && rlCols && rlCols[attr.binding])
}
